(() => {
  const cleanLabel = (value) => value
    .replace(/📅|🗓️|🗓︎|🗓/g, '🗓︎ ')
    .replace(/🕙/g, ' · ')
    .replace(/\s*·\s*/g, ' · ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  const cleanCourseVariantLabels = () => {
    const courseProduct = document.querySelector('.Product--bbqrCourse');
    if (!courseProduct) return;

    courseProduct.querySelectorAll('.ProductForm__Variants .SizeSwatch, .ProductForm__Variants .ProductForm__SelectedValue').forEach((element) => {
      if (element.classList.contains('bbqr-course-term')) return;
      const cleaned = cleanLabel(element.textContent || '');
      if (cleaned && cleaned !== element.textContent) {
        element.textContent = cleaned;
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanCourseVariantLabels, { once: true });
  } else {
    cleanCourseVariantLabels();
  }

  document.addEventListener('shopify:section:load', cleanCourseVariantLabels);
})();
